import { localize, configure, setInteractionMode } from 'vee-validate';

import '@/config/vee_validate/rules/basic';
import '@/config/vee_validate/rules/password';
import '@/config/vee_validate/rules/student_password';
import '@/config/vee_validate/rules/jp_postal_code';
import '@/config/vee_validate/rules/katakana';
import '@/config/vee_validate/rules/phone_number';
import '@/config/vee_validate/rules/corporation_id_unique';
import '@/config/vee_validate/rules/brand_id_unique';
import '@/config/vee_validate/rules/school_id_unique';
import '@/config/vee_validate/rules/teacher_id_unique';
import '@/config/vee_validate/rules/student_id_unique';
import '@/config/vee_validate/rules/video_viewing_id_unique';
import '@/config/vee_validate/rules/dedicated_trial_code';
import '@/config/vee_validate/rules/digits_between_1_100';
import '@/config/vee_validate/rules/alphanumeric';
import '@/config/vee_validate/rules/alphanumeric_hyphen_underbar';
import '@/config/vee_validate/rules/alphabet';

// first validates when the user leaves the input (on blur or change) then if the input is invalid it will behave
// aggressively until the input is valid again and it will go back to being lazy.
setInteractionMode('eager');

// Add new Interaction mode
setInteractionMode('onKeyUp', () => {
  return { on: ['input'] };
});

// Setup invalid messages
localize({
  jp: {
    messages: {
      required: '未入力',
      required_select: '未選択',
      password: '半角英数字8文字以上で入力してください',
      student_password: '数字と英字を最低１つ含む４文字以上で入力してください',
      verify_password: '確認パスワードが一致しません',
      email: '半角英数字で入力してください',
      integer: '半角数字で入力してください',
      phone_number: '半角数字で入力してください',
      length: '{length}文字で入力してください',
      min: '{length}文字以上入力してください',
      jp_postal_code: 'ハイフンなし7桁',
      jp_postal_code_invalid: '郵便番号が無効です',
      corporation_id_unique: 'このIDは既に使用されています',
      brand_id_unique: 'このIDは既に使用されています',
      school_id_unique: 'このIDは既に使用されています',
      teacher_id_unique: 'このIDは既に使用されています',
      student_id_unique: 'このIDは既に使用されています',
      video_viewing_id_unique: 'このIDは既に使用されています',
      dedicated_trial_code: '半角英数字を入力',
      digits_between_1_100: '半角数字1〜100の値を入力',
      katakana: 'カタカナ文字を入力してください',
      alphanumeric: '英数字を入力してください',
      alphanumeric_hyphen_underbar: '半角英数字を入力（-、_は可）',
      alphabet: 'アルファベット文字を入力してください。',
    },
  },
});

// Set error messages in japanese
localize('jp');

// add class when input valid or invalid
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
});
